import { type FC } from "react";
import { IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface CopyComponentProps {
	readonly data: string | number | null | undefined;
}

export const CopyComponent: FC<CopyComponentProps> = ({ data }) => (
	<IconButton
		type="button"
		onClick={() => {
			if (data !== null && data !== undefined) {
				navigator.clipboard.writeText(String(data));
			}
		}}
	>
		<ContentCopyIcon />
	</IconButton>
);
